export default {
  header: 'Schematrons',
  newSchematron: 'New Schematron',
  editSchematron: 'Edit Schematron',
  versions: 'Versions',
  uploadVersion: 'Upload New Version',
  deleteConfirmationHeading: 'Delete schematron?',
  deleteConfirmationText:
    'The ruleset, all of its versions and their files will be removed. Clients validating '
    + 'against it will stop doing so.',
  deleteVersionConfirmationHeading: 'Delete version?',
  publishConfirmationHeading: 'Publish this version?',
  publishConfirmationText: 'It becomes the version every client of this ruleset validates against.',
  compiling: 'Compiling the schematron, this takes a few seconds…',
  fieldsLocked: 'Dataset and NEMSIS version are fixed once a version exists - the rules are written against them.',
  autoAssignHint: {
    national: 'Applies to every client on this NEMSIS version.',
    state: 'Applies to every client in this state.',
    county: 'Never automatic - attach it to each client that needs it.',
    client: 'Applies to the client it belongs to while Active.',
  },
  clientPanel: {
    title: 'Schematrons',
    empty: 'No schematrons apply to this client.',
    applied: 'Applied',
    excluded: 'Excluded',
    available: 'Available',
    auto: 'Automatic',
    manual: 'Manual',
    resetHint: 'Back to default',
  },
};
